// Import DeviceUUID from ESM build (forced via vite.config.ts alias)
// The ESM build exports DeviceUUID as a named export
import { DeviceUUID } from 'device-uuid'

/**
 * Gets or creates a unique device identifier
 * Uses device-uuid to generate a stable UUID based on device characteristics
 */
export function getDeviceId(): string {
  if (!DeviceUUID || typeof DeviceUUID !== 'function') {
    throw new Error(
      `Failed to load DeviceUUID from device-uuid module. ` +
        `DeviceUUID type: ${typeof DeviceUUID}`
    )
  }

  const deviceUuid = new DeviceUUID().get()

  // Validate the UUID is a string
  if (typeof deviceUuid !== 'string' || deviceUuid.length === 0) {
    throw new Error(`Invalid device UUID generated: ${deviceUuid} (type: ${typeof deviceUuid})`)
  }

  console.log('Generated device ID:', deviceUuid, 'type:', typeof deviceUuid)

  return deviceUuid
}
